import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-pv.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-pv.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ViewApplicationDetailsPvConstants } from "./view-application-details-pv.constants";
import { CreateApplicationDetailsPvConstants } from "../../../../../application/create-application/modules/pv/create-application-details-pv/create-application-details-pv.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../../../application/create-application/shared/application-create.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ViewApplicationService } from "../../../view-application.service";
import { DatePipe } from "@angular/common";
import { PropertyValuationService } from "../../../../../shared/services/modules/property-valuation.service";
import { take, takeUntil } from "rxjs/operators";
import { AppConfig } from "src/app/app.config";
let ViewApplicationDetailsPvComponent = class ViewApplicationDetailsPvComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    createApplicationService;
    viewApplicationService;
    appController;
    propertyValuationService;
    route;
    datePipe;
    requestStatusService;
    changeDetectorRefs;
    routerParamsService;
    detailsForm;
    validationMessages = CreateApplicationDetailsPvConstants.VALIDATION_MESSAGES;
    valuationRollSelectLabel = CreateApplicationDetailsPvConstants.VALUATION_ROLL_SELECT_LABEL;
    valuationRollSelectFormControlName = CreateApplicationDetailsPvConstants.VALUATION_ROLL_SELECT_FORM_CONTROL_NAME;
    descriptionLabel = CreateApplicationDetailsPvConstants.DESCRIPTION_LABEL;
    descriptionFormControlName = CreateApplicationDetailsPvConstants.DESCRIPTION_FORM_CONTROL_NAME;
    valuationMethodSelectLabel = CreateApplicationDetailsPvConstants.VALUATIONBLOCK_METHOD_SELECT_LABEL;
    valuationMethodSelectFormControlName = CreateApplicationDetailsPvConstants.VALUATIONBLOCK_METHOD_SELECT_FORM_CONTROL_NAME;
    valuationSplitMethodFormArrayControlName = CreateApplicationDetailsPvConstants.VALUATION_BLOCK_SPLIT_METHOD_FORM_NAME;
    valuationSplitMethodFormControlName = CreateApplicationDetailsPvConstants.VALUATION_BLOCK_SPLIT_METHOD_FORM_CONTROL_NAME;
    propertyTypeSelectLabel = CreateApplicationDetailsPvConstants.PROPERTY_TYPE_SELECT_LABEL;
    propertyTypeSelectFormControlName = CreateApplicationDetailsPvConstants.PROPERTY_TYPE_SELECT_FORM_CONTROL_NAME;
    hybridMethodsLabel = CreateApplicationDetailsPvConstants.HYBRID_METHODS;
    valuationReasonLabel = CreateApplicationDetailsPvConstants.VALUATION_REASON_LABEL;
    valuationReasonCtrl = CreateApplicationDetailsPvConstants.VALUATION_REASON_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addValuationMethodTypeLabel = "Add valuation method";
    hybridMixed = "Hybrid - mixed";
    hybridSplit = "Hybrid - split";
    valuationRollOptions = [];
    valuationMethodOptions = [];
    valuationMethodSplitOptions = [];
    valuationMethodSplitOptionsList = new Array();
    propertyTypesOptions = [];
    propertyTypeCodes = [];
    applicationSubscription;
    saveBtnPlaceholder = ViewApplicationDetailsPvConstants.SAVE_BUTTON_PLACEHOLDER;
    application;
    getLookupsObservableSubscription;
    methodAliases = [];
    constructor(aflaModuleStrategyService, createApplicationService, viewApplicationService, appController, propertyValuationService, route, datePipe, requestStatusService, changeDetectorRefs, routerParamsService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.createApplicationService = createApplicationService;
        this.viewApplicationService = viewApplicationService;
        this.appController = appController;
        this.propertyValuationService = propertyValuationService;
        this.route = route;
        this.datePipe = datePipe;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
    }
    handleRouteChange() {
        if (this.aflaModuleStrategyService.lookups.has("valuationMethodSplitTypes")) {
            this.valuationMethodSplitOptions =
                this.aflaModuleStrategyService.lookups.get("valuationMethodSplitTypes");
            this.propertyTypesOptions =
                this.aflaModuleStrategyService.lookups.get("propertyTypes");
            this.propertyTypeCodes =
                this.aflaModuleStrategyService.lookups.get("propertyCodes");
            this.valuationMethodOptions = this.aflaModuleStrategyService.lookups.get("valuationMethodTypes");
            this.getCurrentApplication();
        }
        else {
            this.getLookups();
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
        const valuationMethodControl = this.getSplitValuationMethodTypes();
        while (valuationMethodControl.controls.length > 0) {
            if (valuationMethodControl.at(0)) {
                valuationMethodControl.removeAt(0);
            }
        }
    }
    getValuationRolls() {
        const dateString = this.datePipe.transform(new Date(), "yyyy-MM-dd") + "T00:00:00Z";
        const params = {
            $expand: "projectCycle,parentValuationRoll",
            $filter: `moduleId eq ${this.appController.selectedModuleID} and ((completed eq false and toDate ge ${dateString}) or id eq ${this.application.valuationRollId})`,
            $orderby: "name",
        };
        this.createApplicationService
            .getValuationRolls(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (rolls) => {
                this.valuationRollOptions = rolls.value;
                this.populateForm();
                this.changeDetectorRefs.markForCheck();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsPvConstants.STEP_TITLE, error, CRUDOperation.Get);
            },
        });
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    getLookups() {
        const runParams = {
            $filter: `moduleId eq ${this.moduleID} and completed eq false`,
            $orderby: "description",
        };
        const lookupParams = {
            $filter: `moduleId eq ${this.moduleID}  and (name eq 'ApplicationType' or name eq 'PropertyType' or name eq 'ValuationMethod')`,
        };
        this.getLookupsObservableSubscription = this.createApplicationService
            .getLookupsObservable(lookupParams)
            .subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsPvConstants.STEP_TITLE, error, CRUDOperation.Get);
            },
        });
    }
    onGetLookupsCompleted(response) {
        const propertyTypeCodes = [];
        const propertyTypes = [];
        const valuationMethodTypes = [];
        const valuationMethodSplitTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach((item) => {
                if (item.name === "PropertyType") {
                    propertyTypeCodes.push(JSON.parse(item.content).code);
                    const d = JSON.parse(item.content);
                    const existingLkIndex = propertyTypes.findIndex((x) => x.code == d.code);
                    if (existingLkIndex == -1)
                        propertyTypes.push(JSON.parse(item.content));
                }
                if (item.name === "ValuationMethod") {
                    valuationMethodTypes.push(JSON.parse(item.content));
                    const i = JSON.parse(item.content);
                    if (i.value !== this.hybridSplit && i.value !== this.hybridMixed) {
                        valuationMethodSplitTypes.push(i);
                    }
                }
            });
        }
        this.methodAliases = AppConfig.settings.propertyValuation.methodAliases;
        valuationMethodTypes.forEach((x) => {
            x.value = this.methodAliases[x.value];
        });
        this.aflaModuleStrategyService.lookups.set("propertyCodes", this.propertyTypeCodes);
        this.aflaModuleStrategyService.lookups.set("propertyTypes", propertyTypes);
        this.propertyTypesOptions = propertyTypes;
        this.propertyTypesOptions.sort((a, b) => a.code?.localeCompare(b?.code));
        this.aflaModuleStrategyService.lookups.set("valuationMethodTypes", valuationMethodTypes);
        this.valuationMethodOptions = valuationMethodTypes;
        this.valuationMethodOptions.sort((a, b) => a.value?.localeCompare(b?.value));
        this.aflaModuleStrategyService.lookups.set("valuationMethodSplitTypes", valuationMethodSplitTypes);
        this.valuationMethodSplitOptions = valuationMethodSplitTypes;
        this.valuationMethodSplitOptions.sort((a, b) => a.value?.localeCompare(b?.value));
        this.getCurrentApplication();
    }
    getSplitValuationMethodTypes() {
        return this.detailsForm.get(this.valuationSplitMethodFormArrayControlName);
    }
    onBtnRemoveValuationMethodClicked(i) {
        const controls = this.getSplitValuationMethodTypes();
        if (controls.controls.length > 1) {
            const lookups = controls.at(i).value;
            for (let index = 0; index < this.application.hybridMethods.length; index++) {
                if (lookups.valuationSplitMethodControlName) {
                    if (this.application.hybridMethods[index].id ===
                        lookups.valuationSplitMethodControlName.id &&
                        lookups.valuationSplitMethodControlName.id > 0) {
                        this.application.hybridMethods[index].deleted = true;
                    }
                }
            }
            this.valuationMethodSplitOptionsList.splice(i, 1);
            controls.removeAt(i);
        }
    }
    onBtnAddValuationMethodClicked() {
        const valuationMethodControl = this.getSplitValuationMethodTypes();
        const typeGroup = new FormGroup({
            valuationSplitMethodControlName: new FormControl(null, [
                Validators.required,
            ]),
        });
        valuationMethodControl.push(typeGroup);
        this.valuationMethodSplitOptionsList[this.valuationMethodSplitOptionsList.length] = JSON.parse(JSON.stringify(this.valuationMethodSplitOptions));
    }
    getCurrentApplication() {
        const params = {
            $expand: `hybridMethods,valuationRoll`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.applicationSubscription = this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe({
            next: (response) => {
                if (response && response.value.length > 0) {
                    this.application = response.value[0];
                    this.getValuationRolls();
                }
            },
            error: (error) => {
                this.requestStatusService.removeBusySpinner("LoadingApplications");
                this.appController.handleServerErrorMessage(ViewApplicationDetailsPvConstants.STEP_TITLE, error, CRUDOperation.Get);
            },
        });
    }
    populateForm() {
        if (this.application) {
            this.detailsForm.reset();
            const valuationMethodControl = this.getSplitValuationMethodTypes();
            while (valuationMethodControl.length !== 0) {
                valuationMethodControl.removeAt(0);
            }
            const valuationRoll = this.valuationRollOptions.find((t) => t.id === this.application.valuationRollId);
            this.detailsForm
                .get(this.valuationRollSelectFormControlName)
                .setValue(valuationRoll.id);
            this.detailsForm
                .get(this.descriptionFormControlName)
                .setValue(this.application.description);
            this.detailsForm
                .get(this.valuationReasonCtrl)
                .setValue(this.application.valuationReason);
            const d2 = this.valuationMethodOptions.find((t) => t.code === this.application.method ||
                t.value === this.application.method);
            this.detailsForm
                .get(this.valuationMethodSelectFormControlName)
                .setValue(d2);
            const d3 = this.propertyTypesOptions.find((t) => t.code === this.application.propertyType ||
                t.value === this.application.propertyType);
            this.detailsForm.get(this.propertyTypeSelectFormControlName).setValue(d3);
            if (this.valuationMethodSplitOptions && d2) {
                let index = 0;
                this.application.hybridMethods.forEach((m) => {
                    this.valuationMethodSplitOptionsList[index] = JSON.parse(JSON.stringify(this.valuationMethodSplitOptions));
                    this.valuationMethodSplitOptionsList[index].forEach((x) => {
                        x.id = m.id;
                    });
                    const d4 = this.valuationMethodSplitOptionsList[index].find((t) => t.code === m.method || t.value === m.method);
                    this.initMethods(d4);
                    index++;
                });
            }
        }
        this.detailsForm.get(this.descriptionFormControlName).disable();
        this.detailsForm.get(this.valuationReasonCtrl).disable();
        this.detailsForm.get(this.valuationRollSelectFormControlName).disable();
        this.changeDetectorRefs.detectChanges();
    }
    initMethods(data = null) {
        const valuationMethodControl = this.getSplitValuationMethodTypes();
        const typeGroup = new FormGroup({
            valuationSplitMethodControlName: new FormControl(data, [
                Validators.required,
            ]),
        });
        if (data && data !== undefined) {
            valuationMethodControl.push(typeGroup);
        }
        this.changeDetectorRefs.detectChanges();
    }
    onBtnSaveClicked($event) {
        if (this.detailsForm.valid) {
            const obj = {
                method: this.detailsForm.get(this.valuationMethodSelectFormControlName)
                    .value.value,
            };
            const lookups = this.detailsForm.get(this.valuationSplitMethodFormArrayControlName).value;
            this.propertyValuationService
                .patchApplication(obj, this.application.id)
                .subscribe((resp) => {
                const hybridMethods = [];
                lookups.forEach((el) => {
                    const vm = {
                        valuationBlockId: this.application.id,
                        method: el.valuationSplitMethodControlName.code,
                        deleted: false,
                        id: +el.valuationSplitMethodControlName.id > 0
                            ? el.valuationSplitMethodControlName.id
                            : 0,
                    };
                    hybridMethods.push(vm);
                });
                hybridMethods.push(...this.application.hybridMethods.filter((x) => x.deleted));
                if (hybridMethods && hybridMethods.length > 0)
                    this.propertyValuationService
                        .setHybridMethods({ hybridMethods }, this.application.id)
                        .subscribe((r) => {
                        this.getCurrentApplication();
                    });
            });
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ApplicationCreateService },
        { type: ViewApplicationService },
        { type: AppControllerService },
        { type: PropertyValuationService },
        { type: ActivatedRoute },
        { type: DatePipe },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsPvComponent = __decorate([
    Component({
        selector: "app-view-application-details-pv",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsPvComponent);
export { ViewApplicationDetailsPvComponent };
